import React from 'react'
import { Modal } from 'react-bootstrap'

const VideoTutorialModalNewUser = ({ show, onClose, videoUrl }) => {
    return (
        <>
            <Modal show={show} onHide={onClose} backdrop="static" centered size="xl" className="video-modal-dialog">
                <Modal.Body>
                    <button
                        type="button"
                        className="video-modal-close-btn"
                        onClick={onClose}
                    >
                        <i className="far fa-times-circle"></i>
                    </button>
                    <div className="video_modal_body">
                        <iframe
                            width="100%"
                            height="100%"
                            src={videoUrl}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default VideoTutorialModalNewUser